module.exports = __webpack_public_path__ + "static/media/slide_9.12c63b5c.jpg";